export default __webpack_public_path__ + "static/media/hand-left-back.c8e2fae4.png";